import React from "react";
import { Button, Grid, Stack } from "@mui/material";
import Icon from "src/components/icon";
import styled from "styled-components";
import slack from "src/assets/icons/slack";
import { getSlackRedirectUrl } from "src/scenes/integrations/utils";
import Link from "src/components/link";
import { Helmet } from "react-helmet";

const H1 = styled.h1`
    font-size: 22px;
    margin: 0;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const P = styled.h2`
    font-size: 12px;
    font-weight: normal;
    margin: 0;
    ${({ theme }) => theme.breakpoints.up("sm")} {
        width: 50%;
    }
    color: ${({ theme }) => theme.palette.secondary.main};
`;

const PermissionsIcon = styled(Icon)`
    background-color: #fff;
    border-radius: 16px;
    padding: 24px 12px 24px 12px;
    margin: 32px 0 32px 0;
`;

const handleClick = () => {
    window.location.replace(
        `https://slack.com/oauth/v2/authorize?client_id=${
            process.env.SLACK_CLIENT_ID
        }&scope=channels:history,channels:read,chat:write,commands,groups:history,groups:read,im:history,im:read,mpim:history,mpim:read,users:read,users:read.email,workflow.steps:execute,team:read,dnd:read,emoji:read,reactions:read&user_scope=channels:history,channels:read,groups:history,groups:read,im:history,im:read,mpim:history,mpim:read,team:read,usergroups:read,users:read,users:read.email,dnd:read,emoji:read,reactions:read&redirect_uri=${getSlackRedirectUrl()}`
    );
};

const TextPlaceholder =
    "While the Slack permissions that we require include the capability to read messages, we store only message metadata. We do not store or parse any message text. At the moment Slack does not offer a permission set that allows only for the reading of message metadata.";

const ContactPlaceholder =
    "In case of any inquiry regarding software permissions, please do not hesitate to ";

const PermissionsSlack = () => {
    return (
        <>
            <Helmet>
                <title>Adadot - Slack Permissions</title>
            </Helmet>
            <Grid container justifyContent="center" mb={4}>
                <Stack
                    direction="column"
                    alignItems="flex-start"
                    style={{ height: "100%", width: "70%" }}
                >
                    <H1>Slack Integration</H1>
                    <H2>How adadot handles your Slack data</H2>
                    <PermissionsIcon svg={slack} width="100px" height="127" />
                    <P>{TextPlaceholder}</P>
                    <P style={{ marginTop: "12px" }}>
                        {ContactPlaceholder}
                        <Link to="/upgrade/inquiry">contact us</Link>
                    </P>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={handleClick}
                        style={{ width: "102px", marginTop: "32px" }}
                    >
                        Continue
                    </Button>
                </Stack>
            </Grid>
        </>
    );
};

export default PermissionsSlack;
